export const TIME_UNIT_OPTIONS = [
    { name: 'Month', value: 'month' },
    { name: 'Day', value: 'day' },
    { name: 'Hour', value: 'hour' },
    { name: 'Minute', value: 'minute' }
];

export const getTimeUnitFromDateFilter = (dateFilter) => {
    if (dateFilter.key === 'last24h') return 'hour';
    if (dateFilter.key === 'last365Days') return 'month';
    return 'day';
};

export const getTimeUnitLabel = (timeUnit) => {
    switch (timeUnit) {
        case 'hour':
            return 'Hourly Data';
        case 'minute':
            return 'Minute Data';
        case 'month':
            return 'Monthly Data';
        default:
            return 'Daily Data';
    }
};